<template>
	<div class="card card-podcast">
		<div v-bind:class="item.Url == '' ? 'card-content' : 'card-content podcast-content'">
			<div class="card-content-wrap">
				<component v-bind:is="item.Url != '' ? 'a' : 'div'"
						   v-bind:href="item.Url != '' ? item.Url.replace('~/','/') : null"
						   v-bind:class="item.Url != '' ? 'card-content-wrap-inner' : 'card-content-wrap-inner'"
						   v-bind:target="item.Url != '' ? (item.Url.indexOf('/') == 0 ? '_self' : '_blank') : null">
					<div v-if="item.Eyebrow" class="card-content-wrap-eyebrow">
						<p>
							{{ item.Eyebrow }}
						</p>
					</div>
					<div v-if="item.Image" class="card-content-wrap-image">
						<img v-bind:src="item.Image" v-bind:alt="item.Alt" />
					</div>
					<h2 class="card-content-wrap-title">{{ item.Title }}</h2>
					<div v-if="displaySummary" class="card-content-wrap-description">
						<p v-if="displayDate" class="pos-left mr-md-1">
							<em>{{ formatDate(item.Date) }} - </em>
						</p>
						<span v-html="item.Summary"></span>
					</div>
				</component>
			</div>
			<div v-if="item.Media" v-html="item.Media" class="card-content-media"></div>
			<div v-if="!displaySummary" class="card-content-footer">
				<div class="row">
					<div class="col-6 card-content-footer-date">
						<p v-if="displayDate">
							{{ formatDate(item.Date) }}
						</p>
					</div>
					<div class="col-6 card-content-footer-cta">
						<a v-if="item.Url" v-bind:href="item.Url != '' ? item.Url : null" v-bind:target="item.Url != '' ? (item.Url.indexOf('/') == 0 ? '_self' : '_blank') : null">Episode Details</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';

	export default {
		props: ['item', 'displayDate', 'displaySummary'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDate(date) {
				return DateFormatService.formatDate(date);
			},
        },
    }
</script>